<template>
  <div class="headerbar">
    <div>{{ welcomeMessage }}</div>
    <div>您好，欢迎！</div>
  </div>
</template>

<script setup>
const date = new Date();
const welcomeMessage = '登录时间：' + date.toLocaleString();


</script>

<style scoped>
.headerbar {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
</style>
